/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_1_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a desktop app to try GridCraft?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_1_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用 GridCraft 必须安装桌面应用吗？`)
};

/**
* | output |
* | --- |
* | "Do I need a desktop app to try GridCraft?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_1_question = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_1_question(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_1_question(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_1_question as "gc.search_guides.what_is_gridcraft.sections.8.questions.1.question" }